import { useState } from 'react';
import { isAxiosError } from 'axios';
import { registerModuleApi } from 'modules/RegisterModule/api';
import { FetchStatus } from 'types/api';

export const useValidateInvite = () => {
  const [status, setStatus] = useState<FetchStatus>('idle');
  const [error, setError] = useState<string>();
  const [isValid, setIsValid] = useState<boolean | null>(null);

  const validateInvite = async (token: string) => {
    try {
      setStatus('loading');
      const result = await registerModuleApi.validateToken(token);
      setIsValid(result);
      setStatus('success');
    } catch (responseError) {
      setStatus('failed');
      if (isAxiosError(responseError)) {
        setError(responseError.response?.data);
      } else {
        setError(JSON.stringify(responseError));
      }
    }
  };

  return { status, error, isValid, validateInvite };
};
